import { computePaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  { scope: 'Internal.Opennebula', category: 'compute', route: computePaths.service },
  { scope: 'Internal.VMware', category: 'compute', route: computePaths.service },
  // Private VMware: a compute service with no console of its own wired yet.
  { scope: 'Internal.VMware.Private', category: 'compute' },
] as const;
